var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-pane-inner" }, [
    _c("div", { staticClass: "go-add-input" }, [
      _c("div", { staticClass: "go-btn-group" }, [
        _c(
          "button",
          {
            staticClass: "btn go-btn-default",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$refs.file.click()
              },
            },
          },
          [
            _vm._m(0),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "popupAddReference.filesTab.childTabOfFilesTitle.myComputer"
                  )
                ) +
                "\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          ref: "file",
          staticClass: "d-none",
          attrs: {
            id: "fileUpload",
            accept: _vm.acceptUploadFile,
            multiple: "",
            name: "fileUpload",
            type: "file",
          },
          on: {
            input: function ($event) {
              return _vm.uploadFromPC(_vm.$refs.file["files"])
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn go-btn-default",
            attrs: { type: "button" },
            on: { click: _vm.googleSignin },
          },
          [
            _vm._m(1),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "popupAddReference.filesTab.childTabOfFilesTitle.googleDriver"
                  )
                ) +
                "\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn go-btn-default",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.launchOneDrivePicker()
              },
            },
          },
          [
            _vm._m(2),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "popupAddReference.filesTab.childTabOfFilesTitle.oneDriver"
                  )
                ) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "go-list-wrap" },
      [
        _c(
          "vue-custom-scrollbar",
          {
            staticClass:
              "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
            attrs: { settings: _vm.scrollSettings },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "auto",
                  height: "auto",
                },
              },
              [
                _c(
                  "ul",
                  { staticClass: "go-card-sub-list go-card-resource" },
                  _vm._l(_vm.uploadQueueFiles, function (refItem, index) {
                    return _c("ref-item", {
                      key: refItem.id + index,
                      attrs: {
                        "form-model": refItem,
                        "is-file-card": true,
                        "remove-able": true,
                      },
                      on: {
                        remove: function ($event) {
                          return _vm.removeCardInList(refItem)
                        },
                        toggleBookmark: function ($event) {
                          return _vm.selectAddingReferenceDocument(refItem)
                        },
                      },
                    })
                  }),
                  1
                ),
              ]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-icon-area" }, [
      _c("i", { staticClass: "go-icon-18 go-icon-device-laptop" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-icon-area" }, [
      _c("i", { staticClass: "go-icon-18 go-icon-drive-google" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-icon-area" }, [
      _c("i", { staticClass: "go-icon-18 go-icon-drive-one" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }